import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline';
  size?: 'sm' | 'default';
}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    return (
      <div
        className={cn(
          'inline-flex items-center rounded-full font-medium transition-colors',
          {
            'bg-primary text-primary-foreground': variant === 'default',
            'bg-secondary text-secondary-foreground': variant === 'secondary',
            'bg-green-500/10 text-green-700 dark:bg-green-500/20 dark:text-green-400': variant === 'success',
            'bg-yellow-500/10 text-yellow-700 dark:bg-yellow-500/20 dark:text-yellow-400': variant === 'warning',
            'bg-red-500/10 text-red-700 dark:bg-red-500/20 dark:text-red-400': variant === 'destructive',
            'border border-border bg-background text-foreground': variant === 'outline',
            'px-2 py-0.5 text-[10px]': size === 'sm',
            'px-2.5 py-0.5 text-xs': size === 'default'
          },
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export { Badge };
